import React, { Component } from "react";
import { profile, branch, alert, total, float, toFixed, format_date, random_charactor, GET, POST, PUT, DELETE, loading, Status, params, required, DatePicker, Select, BtnIcon, Swal, Pagination, Switch, Navbar, Modal, Resizer } from "../../../components/CustomComponent.js";
export default class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",

      data: [],
      count: 10,
      data_warehouse: [],
      data_role: [],

      id: "",
      uid: "",
      full_name: "",
      phone: "",
      user_type: "",
      role_id: "",
      email: "",
      password: "",
      photo: "",
      warehouse_list: [],
      password_view: "password",
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    let data, count, data_warehouse, data_role;
    loading(true);
    let [result, result_warehouse, result_role] = await Promise.all([GET("admin/setting/users/list", { page: page, data_search: this.state.filter_search }), GET("admin/setting/warehouses/list", { page: 0, data_search: "" }), GET("admin/setting/roles/list", { page: 0, data_search: "" })]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({ value: e.id, label: e.name }));
    }
    if (result_role?.status) {
      data_role = result_role.data.map((e) => ({ value: e.uid, label: e.name }));
    }
    this.setState({
      data,
      count,
      data_warehouse,
      data_role,
    });
    loading(false);
  };
  CreateUpdate = async () => {
    const { uid, full_name, phone, user_type, role_id, email, password, photo, warehouse_list } = this.state;
    if (!full_name.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อ-นามสกุล");
      return;
    } else if (!phone.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทร");
      return;
    } else if (!user_type.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกประเภทผู้ใช้งาน");
      return;
    } else if (email.length < 4) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อผู้ใช้มากกว่า 4 ตัวอักษร");
      return;
    } else if (warehouse_list.length === 0) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกคลังสินค้าสินค้าอย่างน้อย 1 คลังสินค้า");
      return;
    } else if (password && password.length < 4) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกรหัสผ่านมากกว่า 4 ตัวอักษร");
      return;
    }

    loading(true);
    let body = {
      full_name,
      phone,
      user_type,
      role_id,
      email,
      password,
      warehouse_list,
    };

    let result = !uid ? await POST("admin/setting/users/create", body) : await PUT("admin/setting/users/update/" + uid, body);
    if (result?.status) {
      alert("#", "success");
    } else {
      alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง");
    }
    loading(false);
  };
  Delete = async (id) => {
    if (await alert("", "warning", "ลบข้อมูล", "ยืนยันการลบรายการนี้หรือไม่ ?", "ลบข้อมูล", "ยกเลิก")) {
      loading(true);
      let result = await DELETE("admin/setting/users/delete/" + id, null);
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  render() {
    const { modal_create, modal_update, filter_search, data, count, data_warehouse, data_role, id, uid, full_name, phone, user_type, role_id, email, password, photo, warehouse_list, password_view } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">ผู้ใช้งาน</h4>
              <button
                className="btn btn-dark px-3 ms-auto mb-2 banks.create"
                onClick={async () => {
                  this.setState({ id: "", uid: "", full_name: "", phone: "", user_type: "", role_id: "", email: "", password: "", photo: "", warehouse_list: [], modal_create: true, password_view: "password" });
                }}
              >
                เพิ่มรายการ
              </button>
            </div>
            <div className="d-flex flex-wrap">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างค่า
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">ลำดับ</td>
                    <td className="text-nowrap">รหัสพนักงาน</td>
                    <td className="text-nowrap">ชื่อ-นามสกุล</td>
                    <td className="text-nowrap">เบอร์โทร</td>
                    <td className="text-nowrap">ชื่อผู้ใช้</td>
                    <td className="text-nowrap">ประเภท</td>
                    <td className="text-nowrap">บทบาท</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">{index + 1}</td>
                      <td className="text-nowrap">{item.user_code || "-"}</td>
                      <td className="text-nowrap">{item.full_name || "-"}</td>
                      <td className="text-nowrap">{item.phone || "-"}</td>
                      <td className="text-nowrap">{item.email || "-"}</td>
                      <td className="text-nowrap">{item.user_type || "-"}</td>
                      <td className="text-nowrap">{item.role?.name || "-"}</td>
                      <td className="text-center align-middle wpx-100">
                        <div className="d-flex">
                          <BtnIcon
                            className="banks.update"
                            type="update"
                            onClick={() => {
                              this.setState({ ...item, role_id: item?.role?.uid || "", modal_update: true, password_view: "password" });
                            }}
                          />
                          <BtnIcon
                            className="banks.delete"
                            type="delete"
                            onClick={() => {
                              this.Delete(item.uid);
                            }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination className="mb-3" count={Math.ceil(count / 10) || 1} showFirstButton showLastButton onChange={(_, page) => this.Get(page)} />
          </div>
        </div>
        {/* CREATE UPDATE */}
        <Modal show={modal_create || modal_update} onHide={() => this.setState({ modal_create: false, modal_update: false })} size="lg">
          <Modal.Header className="border-0" closeButton>
            <h5 className="fw-bold mb-0">{modal_create ? "เพิ่ม" : modal_update ? "แก้ไข" : ""}ผู้ใช้งาน</h5>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="row">
              <div className="col-12 col-lg-7">
                <h5 className="fw-bold mb-3">ข้อมูลผู้ใช้งาน</h5>
                {/* <div className="d-flex mb-2">
                  <div className="wpx-120 mt-2">รูปภาพ</div>
                  <div className="d-flex flex-wrap">
                    <input
                      hidden
                      accept="image/*"
                      id="image"
                      type="file"
                      onChange={async (e) => {
                        if (e.target.files[0]) {
                          let image = await new Promise((resolve) => {
                            Resizer.imageFileResizer(
                              e.target.files[0],
                              1200,
                              1200,
                              "JPEG",
                              100,
                              0,
                              (uri) => {
                                resolve(uri);
                              },
                              "base64"
                            );
                          });
                          this.setState({ photo: image });
                          e.target.value = "";
                        }
                      }}
                    />
                    {this.state.photo ? (
                      <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                        <img alt="example" src={this.state.photo} className="rounded-3" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                        <span
                          className="wpx-20 hpx-20 rounded-circle bg-danger pointer text-white text-16 position-absolute icon d-flex align-items-center justify-content-center shadow"
                          style={{ right: -8, top: -8 }}
                          onClick={() => {
                            this.setState({ photo: "" });
                          }}
                        >
                          {"\uf00d"}
                        </span>
                      </div>
                    ) : (
                      <div className="d-flex">
                        <div
                          className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-32 text-success bg-success-light rounded-3 pointer"
                          onClick={() => {
                            document.getElementById("image").click();
                          }}
                        >
                          {"\uf03e"}
                        </div>
                        <small className="text-secondary ps-3">
                          <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 1200x1200 พิกเซล เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                          <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF <br />
                          <b>ขนาดไฟล์สูงสุด:</b> 5MB
                        </small>
                      </div>
                    )}
                  </div>
                </div> */}
                <div className="d-flex mb-3">
                  <div className="wpx-120 mt-2">ชื่อ-นามสกุล{required}</div>
                  <input
                    className="form-control"
                    placeholder="ชื่อ-นามสกุล..."
                    onChange={(e) => {
                      this.setState({ full_name: e.target.value });
                    }}
                    value={full_name}
                  />
                </div>
                <div className="d-flex mb-3">
                  <div className="wpx-120 mt-2">เบอร์โทร{required}</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="เบอร์โทร..."
                    maxLength={10}
                    onChange={(e) => {
                      if (!float(e.target.value)) return;
                      this.setState({ phone: e.target.value });
                    }}
                    value={phone}
                  />
                </div>
                <div className="d-flex mb-3">
                  <div className="wpx-120 mt-2">ประเภทผู้ใช้งาน{required}</div>
                  <select
                    className="form-select"
                    placeholder="ประเภทผู้ใช้งาน..."
                    onChange={(e) => {
                      this.setState({ user_type: e.target.value });
                    }}
                    value={user_type}
                  >
                    <option value="">ประเภทผู้ใช้งาน...</option>
                    <option value="admin">ผู้ดูแลระบบ</option>
                    <option value="officer">พนักงานออฟฟิศ</option>
                    <option value="technical">พนักงานช่าง</option>
                  </select>
                </div>
                <div className="d-flex mb-3">
                  <div className="wpx-120 mt-2">บทบาท{required}</div>
                  <Select
                    className="form-control"
                    placeholder="บทบาท..."
                    options={data_role}
                    onChange={(e) => {
                      this.setState({ role_id: e });
                    }}
                    value={role_id}
                  />
                </div>
                <div className="d-flex mb-3">
                  <div className="wpx-120 mt-2">ชื่อผู้ใช้{required}</div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ชื่อผู้ใช้..."
                    onChange={(e) => {
                      this.setState({ email: e.target.value });
                    }}
                    value={email}
                  />
                </div>
                <hr />
                <div className="d-flex mb-3">
                  <div className="wpx-120 mt-2">รหัสผ่าน{required}</div>
                  <div className="position-relative w-100">
                    <input
                      type={password_view}
                      className="form-control"
                      placeholder="รหัสผ่าน..."
                      onChange={(e) => {
                        this.setState({ password: e.target.value });
                      }}
                      value={password}
                    />{" "}
                    <div
                      className="wpx-40 hpx-40 d-flex justify-content-center align-items-center icon pointer position-absolute"
                      style={{ right: 0, top: 0 }}
                      onClick={() => {
                        this.setState({ password_view: this.state.password_view === "password" ? "text" : "password" });
                      }}
                    >
                      {this.state.password_view === "password" ? "\uf06e" : "\uf070"}
                    </div>
                  </div>
                </div>
                {modal_update && <small className="text-secondary">** หาดต้องการเปลี่ยนรหัสผ่านให้ทำการกรอกรหัสผ่านใหม่เข้ามาอัพเดตข้อมูล แต่ถ้าหากไม่ต้องการเปลี่ยน ไม่จำเป็นต้องกรอกรหัสผ่าน</small>}
              </div>
              <div className="col-12 col-lg-5">
                <h5 className="fw-bold mb-3">คลังสินค้า</h5>
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <td>ชื่อคลังสินค้า</td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    {data_warehouse?.map((item, index) => (
                      <tr>
                        <td>{item.label}</td>
                        <td>
                          <input
                            type="checkbox"
                            onChange={() => {
                              let _index = warehouse_list.findIndex((e) => e === Number(item.value));
                              if (_index === -1) {
                                warehouse_list.push(Number(item.value));
                              } else {
                                warehouse_list.splice(_index, 1);
                              }
                              this.setState({ warehouse_list });
                            }}
                            checked={warehouse_list.includes(Number(item.value))}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1"
                onClick={() => {
                  this.CreateUpdate();
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1"
                onClick={() => {
                  this.setState({ modal_create: false, modal_update: false });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
